import PropTypes from 'prop-types';

import RoomCardListLoader from './RoomCardListLoader';
import MobileHeaderLoader from './MobileHeaderLoader';
import PriceMatrixTableLoader from './PriceMatrixTableLoader';
import PriceMatrixSummaryLoader from './PriceMatrixSummaryLoader';

const PriceMatrixLoader = ({ isGlobetrotter, isHotelOnly }) => (
  <div>
    {isGlobetrotter || isHotelOnly ? (
      <RoomCardListLoader isHotelOnly={isHotelOnly} />
    ) : (
      <>
        <MobileHeaderLoader />
        <PriceMatrixTableLoader />
      </>
    )}
    <PriceMatrixSummaryLoader />
  </div>
);

PriceMatrixLoader.propTypes = {
  isGlobetrotter: PropTypes.bool.isRequired,
  isHotelOnly: PropTypes.bool,
};

PriceMatrixLoader.defaultProps = {
  isHotelOnly: false,
};

export default PriceMatrixLoader;
